import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { MembershipContext } from "@context/MembershipContext";
import AboutIcon from "@components/Icons/AboutIcon";
import ExperienceIcon from "@components/Icons/ExperienceIcon";
import MovieClubIcon from "@components/Icons/MovieClubIcon";
import MovieMenuIcon from "@components/Icons/MovieMenuIcon";
import NewsIcon from "@components/Icons/NewsIcon";
import VenueIcon from "@components/Icons/VenueIcon";
import { requestUserLocation } from "@utils/locationUtils";
import "./style.scss";

const LeftSidebarMenu = ({ isOpen }) => {

    const { publicSubscriberGroup } = useContext(ApplicationContext);
    const { user, isLoggedIn, setUserCoords } = useContext(AuthContext);
    const { membershipOptions, fetchMembershipInformation } = useContext(MembershipContext);
    const [isNavCollapsed, setIsNavCollapsed] = useState(false);
    const isMovieRewardsSite = window.location.href.includes("movierewards");

    useEffect(() => {
        if (isLoggedIn === true && user?.id) {
            fetchMembershipInformation(user?.id);
        }
    }, [user?.id]);

    const handleCinemasClick = () => {
        requestUserLocation((coords) => {
            if (coords) {
                setUserCoords(coords);
            }
        });
    };

    const handleLocationClick = () => {
        requestUserLocation((coords) => {
            if (coords) {
                setUserCoords(coords);
            }
        });
    };

    const handleNavCollapse = () => {
        setIsNavCollapsed(!isNavCollapsed);
    };


    return (
        <div className={`left-sidebar-menu ${isOpen ? "open" : "closed"}`}>
            <NavLink
                to="/movies"
                activeClassName="active"
                onClick={handleNavCollapse}
                className="left-sidebar-menu__link">
                <span className="left-sidebar-menu__icon">
                    <MovieMenuIcon />
                </span> Movies
            </NavLink>
            <NavLink
                to="/cinemas"
                activeClassName="active"
                onClick={(e) => {
                    handleNavCollapse();
                    handleCinemasClick();
                }}
                className="left-sidebar-menu__link">
                <span className="left-sidebar-menu__icon">
                    <VenueIcon />
                </span> Cinemas
            </NavLink>
            {!isMovieRewardsSite && (
                <NavLink
                    to="/experiences"
                    activeClassName="active"
                    onClick={(e) => {
                        handleNavCollapse();
                        handleLocationClick();
                    }}
                    className="left-sidebar-menu__link"><span className="left-sidebar-menu__icon">
                        <ExperienceIcon />
                    </span>Experiences
                </NavLink>
            )}
            {membershipOptions ? (
                <NavLink
                    to="/movie-club-membership"
                    activeClassName="active"
                    onClick={handleNavCollapse}
                    className="left-sidebar-menu__link"><span className="left-sidebar-menu__icon">
                        <MovieClubIcon />
                    </span>Movie Club
                </NavLink>
            ) : null}
            {publicSubscriberGroup !== 0 ? (
                <>
                    <NavLink
                        to="/about"
                        activeClassName="active"
                        onClick={handleNavCollapse}
                        className="left-sidebar-menu__link"
                    ><span className="left-sidebar-menu__icon">
                        <AboutIcon />
                    </span>About
                    </NavLink>
                    <NavLink
                        to="/news"
                        activeClassName="active"
                        onClick={handleNavCollapse}
                        className="left-sidebar-menu__link"
                    ><span className="left-sidebar-menu__icon">
                        <NewsIcon />
                    </span>News
                    </NavLink>
                </>

            ) : null}
        </div>
    );
};

export default LeftSidebarMenu;
